import { useState } from 'react';
import { Dumbbell, LockKeyhole, WifiOff } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { Button, Field } from '../components/UI';

export function LoginPage() {
  const { login, error } = useApp();
  const [loginValue, setLoginValue] = useState('admin');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string>();
  const submit = async (event: React.FormEvent) => {
    event.preventDefault(); setBusy(true); setMessage(undefined);
    try { await login(loginValue, password); }
    catch (caught) { setMessage(caught instanceof Error ? caught.message : 'Не удалось войти'); }
    finally { setBusy(false); }
  };
  return <main className="login-page">
    <section className="login-visual">
      <div className="login-visual__content"><div className="brand brand--hero"><div className="brand__mark">С</div><div><strong>Сила</strong><span>тренировочный дневник</span></div></div>
        <h1>Тренировки, которые всегда с тобой.</h1>
        <p>Планируй. Записывай. Становись сильнее — даже когда в зале нет связи.</p>
        <div className="login-features"><span><Dumbbell /> Полный журнал подходов</span><span><WifiOff /> Работает без интернета</span></div>
      </div>
    </section>
    <section className="login-panel"><form onSubmit={submit} className="login-form">
      <div className="login-form__icon"><LockKeyhole /></div><h2>Вход в дневник</h2><p>У каждого пользователя свои тренировки и статистика</p>
      <Field label="Логин" autoComplete="username" value={loginValue} onChange={(event) => setLoginValue(event.target.value)} />
      <Field label="Пароль" type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} autoFocus />
      {(message || error) && <div className="form-error">{message || error}</div>}
      <Button type="submit" disabled={busy || !password}>{busy ? 'Входим…' : 'Войти'}</Button>
      <small>При первом запуске используйте пароль из файла .env</small>
    </form></section>
  </main>;
}
